export const teamMembers = [
  {
    id: 1,
    name: 'Olivia Embry',
    slug: 'olivia-embry',
    // Registration number with CMTO — shown on the profile once provided.
    registration: null,
    title: 'RMT',
    fullTitle: 'Registered Massage Therapist',
    image: '/team/olivia.jpg',
    shortBio:
      'Combines hands-on treatment with education and movement-based strategies to help clients manage pain, improve mobility, and feel more comfortable in their bodies.',
    bio: "Olivia combines hands-on treatment with education and movement-based strategies to help clients manage pain, improve mobility, and feel more comfortable in their bodies. Her approach is collaborative, practical, and tailored to each person's lifestyle and goals.",
    specialties: [
      'Neck & back pain',
      'TMJ dysfunction & jaw tension',
      'Chronic pain',
      'Desk workers',
    ],
    treatmentStyle: {
      pressure: 'Moderate–Firm',
      approach: 'Thorough · Educational · Collaborative',
    },
    certifications: [
      'Contemporary Medical Acupuncture Provider',
      'TMJ & Intra-oral Advanced Training',
      'B.Kin, University of Toronto',
    ],
    outsideClinic:
      "When she's not treating, you'll likely find her walking her dog or trying to find the best restaurants in Toronto.",
  },
  {
    id: 2,
    name: 'Brandon Schneider',
    slug: 'brandon-schneider',
    // Registration number with CMTO — shown on the profile once provided.
    registration: null,
    title: 'RMT',
    fullTitle: 'Registered Massage Therapist',
    image: '/team/brandon.jpg',
    shortBio:
      'Blends manual therapy with movement, exercise, and education for a whole-body approach to reducing pain and improving mobility.',
    bio: 'Brandon combines hands-on manual therapy with movement, exercise, and education to help clients reduce pain, improve mobility, and move with greater confidence. Drawing from his background in kinesiology, massage therapy, and osteopathic training, he takes a whole-body approach to uncovering contributing factors rather than simply treating symptoms. Every treatment is individualized to help clients achieve their goals and stay active doing the things they enjoy.',
    specialties: [
      'Neck and back pain',
      'Shoulder, hip, and knee conditions',
      'Mobility and movement optimization',
      'Active individuals and recreational athletes',
    ],
    treatmentStyle: {
      pressure: 'Moderate–Firm',
      approach: 'Analytical · Educational · Collaborative',
    },
    certifications: [
      'B.Sc. Kinesiology, University of Waterloo (Minor in Rehabilitation Sciences)',
      'Year 4 Osteopathy Student, Ontario Academy of Progressive Osteopathy',
      'Contemporary Medical Acupuncture Provider',
      'Titleist Performance Institute Certified (TPI)',
      'Functional Range Conditioning Mobility Specialist (FRCms)',
    ],
    outsideClinic:
      "When he's not treating patients, you'll usually find Brandon on the golf course, in the gym, or continuing his education through osteopathic and movement-based training.",
  },
  {
    id: 3,
    name: 'Jazmin Ulalan',
    slug: 'jazmin-ulalan',
    // Registration number with CMTO — shown on the profile once provided.
    registration: null,
    title: 'RMT',
    fullTitle: 'Registered Massage Therapist',
    image: '/team/jazmin.jpg',
    shortBio:
      'Individualized plans focused on injury prevention, rehabilitation, pain management, and performance for all ages and activity levels.',
    bio: 'Jaz provides individualized plans focused on injury prevention and rehabilitation, pain management, and performance optimization. She has clinical experience treating patients of all ages and activity levels. Her treatments incorporate functional assessments, manual therapy, exercise prescription, and patient education.',
    specialties: [
      'Sport-related hip and leg injuries',
      'Stress-related neck and back pain',
      'Pre and post-natal focus',
      'Desk workers',
    ],
    treatmentStyle: {
      pressure: 'Moderate–Deep',
      approach: 'Movement-based · Educational · Collaborative',
    },
    certifications: [
      'Contemporary Medical Acupuncture Provider',
      'CSMTA Advanced Sport Massage',
    ],
    outsideClinic:
      "When she's not treating, she's playing ultimate frisbee with the Toronto 6ixers team!",
  },
  {
    id: 4,
    name: 'Alana Shnier',
    slug: 'alana-shnier',
    // Registration number with CONO — shown on the profile once provided.
    registration: null,
    title: 'ND',
    fullTitle: 'Naturopathic Doctor',
    image: '/team/alana.jpg',
    shortBio:
      'A root-cause, patient-centered naturopathic doctor combining evidence-based medicine with sustainable lifestyle strategies.',
    bio: "Dr. Alana takes a root-cause, patient-centered approach to healthcare, combining evidence-based naturopathic medicine with practical, sustainable lifestyle strategies. She works collaboratively with patients to understand the factors contributing to their symptoms and create individualized, targeted treatment plans that support both symptom relief and long-term health. Her goal is to help patients feel empowered, understood, advocated for, and supported throughout their health journey.\n\nDr. Alana believes that optimal health comes from addressing the foundations of wellness, including nutrition, sleep, movement, stress management, hydration, and lifestyle habits. She takes a root-cause approach to care, recognizing that many chronic health concerns share common underlying drivers. Rather than focusing solely on symptoms, she works to identify and address the factors contributing to dysfunction while supporting the body's ability to heal. Drawing from a variety of evidence-based therapies, including clinical nutrition, botanical medicine, acupuncture, nutritional supplementation, lifestyle counselling, and laboratory testing, she creates individualized treatment plans that support both symptom relief and long-term wellness.",
    specialties: [
      'Fatigue, low energy, high stress, sleep issues',
      'Hormonal health (PMS, PCOS, fertility, thyroid, perimenopause, menstrual concerns)',
      'Stress & nervous system regulation',
      'Digestive health',
      'Blood sugar balance & metabolic health (weight loss, cholesterol, blood pressure)',
      'Skin health',
      'Pain management',
      'Managing existing chronic health concerns',
      'Preventive & whole-person wellness',
    ],
    treatmentStyle: {
      approach:
        'Targeted · Educational · Collaborative · Evidence-Based · Root-Cause Focused',
    },
    certifications: [
      'Doctor of Naturopathy (ND)',
      'Facial Acupuncture Certification',
      'HBASc, Nutrition & Food — Toronto Metropolitan University',
    ],
  },
  {
    id: 5,
    name: 'Miranda Manolakos',
    slug: 'miranda-manolakos',
    // Registration number with CMTO / CATA — shown on the profile once provided.
    registration: null,
    title: 'CAT(C), RMT',
    fullTitle: 'Certified Athletic Therapist & Registered Massage Therapist',
    image: '/team/miranda.jpg',
    shortBio:
      'Takes an active, movement-focused approach to care, combining hands-on therapy with exercise and education to help clients move better, feel stronger, and stay active.',
    bio: "Miranda takes an active, movement-focused approach to care, combining hands-on therapy with exercise and education to help clients move better, feel stronger, and stay active. As both an Athletic Therapist and Registered Massage Therapist, she draws from both disciplines to create individualized treatment plans that address pain and injury while building strength, mobility, and confidence in movement.\n\nMiranda enjoys working with a wide range of clients, from university and high-school athletes to desk workers and what she likes to call “athletes of life.” Whether you're recovering from an injury, managing the demands of a desk job, training for a sport, or simply looking to move and feel your best, Miranda's goal is to help you stay active in the things that matter to you.",
    specialties: [
      'Injury recovery & rehabilitation',
      'Strength & mobility',
      'Movement-related pain',
      'Active individuals & recreational athletes',
      'Return to activity & sport',
    ],
    treatmentStyle: {
      approach: 'Collaborative · Active · Exercise-focused',
    },
    certifications: [
      'Bachelor of Kinesiology — Wilfrid Laurier University',
      'Bachelor of Applied Health Science in Athletic Therapy — Sheridan College',
      'Diploma in Massage Therapy — Ontario College of Health & Technology',
    ],
  },
]

export const teamBySlug = (slug) => teamMembers.find((m) => m.slug === slug)

export default teamMembers
